import axios from 'axios';
import Cookies from 'js-cookie';

import sha256 from 'crypto-js/sha256';
import md5 from 'crypto-js/md5';

let lang = {};
import langFallback from '@data/label';

export const convertNumber = (value: string | number) => {
  return parseFloat(value.toString()).toFixed(2)
}

export const updateObject = (oldObject, updatedProperties) => {
  return {
    ...oldObject,
    ...updatedProperties,
  };
};

export const getLabels = async (langUrl) => {
  if(langUrl) {
    await axios
      .get(langUrl)
      .then(function (response) {
          lang = response.data;
      })
      .catch(function (error) {
          console.error('>>> Get labels => error status:', error.status, ', error: ', error);
      });
  }
}

export const getLabelFallback = label => {
  if (lang && lang[label]) {
      return lang[label];
  }

  return langFallback[label];
};

export const getYears = () => {
  const actualYear =  new Date().getFullYear();
  let years = [];

  for(let i = 0; i < 12; i++) {
    years[i] = actualYear + i
  }

  return years;
};

export const getActualMonth = () => {
  const month = new Date().getMonth() + 1;
  if(month.toString().length === 1) return '0' + month;
  return month.toString();
}

export const getActualYear = () => {
  return new Date().getFullYear();
}

export const getDateInAmericanFormat = (data) => {
  const d = new Date(data);
  const day = getEnglishDay(d.getDate());
  const month = getStringMonth(d.getMonth());
  const year = d.getFullYear();

  return month + ' ' + day + ', ' + year;
}

const getEnglishDay = (day) => {
  switch(day){
    case 1: case 21: return day + 'st';
    case 1: case 22: return day + 'nd';
    case 3: case 23: return day + 'rd';
    default: return day + 'th';
  }
}

export const getStringMonth = (month) => {
  switch(month){
    case 0: return getLabelFallback('JANUARY_LABEL');
    case 1: return getLabelFallback('FEBRUARY_LABEL');
    case 2: return getLabelFallback('MARCH_LABEL');
    case 3: return getLabelFallback('APRIL_LABEL');
    case 4: return getLabelFallback('MAY_LABEL');
    case 5: return getLabelFallback('JUNE_LABEL');
    case 6: return getLabelFallback('JULY_LABEL');
    case 7: return getLabelFallback('AUGUST_LABEL');
    case 8: return getLabelFallback('SEPTEMBER_LABEL');
    case 9: return getLabelFallback('OCTOBER_LABEL');
    case 10: return getLabelFallback('NOVEMBER_LABEL');
    case 11: return getLabelFallback('DECEMBER_LABEL');
  }
}

export const luhnCheck = (cardNumber) => {
  var trimmed = String(cardNumber).replace(/[\s]/g, "")
    , length = trimmed.length
    , odd = false
    , total = 0
    , calc
    , calc2;

  if (!/^[0-9]+$/.test(trimmed)) {
    return false;
  }

  for (var i = length; i > 0; i--) {
    calc = parseInt(trimmed.charAt(i - 1));
    if (!odd) {
      total += calc;
    } else {
      calc2 = calc * 2;

      switch (calc2) {
        case 10: calc2 = 1; break;
        case 12: calc2 = 3; break;
        case 14: calc2 = 5; break;
        case 16: calc2 = 7; break;
        case 18: calc2 = 9; break;
        default: calc2 = calc2;
      }
      total += calc2;
    }
    odd = !odd;
  }

  return (total !== 0 && (total % 10) === 0);
}

export const getItemTotalPrice = (item) => {
      return convertNumber(parseFloat(item.frame.finalPrice) + 
      parseFloat(item.lenses.finalPrice) + 
      parseFloat(item.addOns.finalPrice));
}

export const getItemTotalPriceWithWarranty = (item, warrantyItemPrice) => {
  console.log(warrantyItemPrice);
  return (parseFloat(getItemTotalPrice(item)) + parseFloat(warrantyItemPrice)).toFixed(2);
}

export const getTotalTax = (cart) => {
  const totalTax = convertNumber(parseFloat(cart.totalShippingTax) + parseFloat(cart.totalSalesTax));
  
  return totalTax === '0.00' ? '--' : getLabelFallback('CURRENCY_LABEL') + totalTax;
}

export const getSubtotal = (cart) => {
  return convertNumber(parseFloat(cart.totalProductPrice) + parseFloat(cart.totalAdjustment) + parseFloat(cart.totalShippingCharge));
}

export const getMMSubtotal = (cart) => {
  return convertNumber(parseFloat(cart.totalProductPrice) + parseFloat(cart.totalAdjustment));
}

export const getItemDiscountedTotalPrice = (item) => {
    return (parseFloat(item.frame.finalDiscountPrice) +
    parseFloat(item.lenses.finalDiscountPrice) + 
    parseFloat(item.addOns.finalDiscountPrice)).toFixed(2)
}

export const getItemDiscountedTotalPriceWithWarranty = (item, warrantyItemPrice) => {
  return (parseFloat(getItemDiscountedTotalPrice(item)) + parseFloat(warrantyItemPrice)).toFixed(2);
}

export const getItemDeiscountedTotalPriceWithSpeedy = (item, speedyPrice) => {
  return (parseFloat(getItemDiscountedTotalPrice(item)) + parseFloat(speedyPrice)).toFixed(2);
}

export const scrollUpPage = (window) => {
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: 'smooth'
  });
}

export const isMobile = {
  Android: () => {
    return navigator.userAgent.match(/Android/i);
  },
  BlackBerry: () => {
    return navigator.userAgent.match(/BlackBerry/i);
  },
  iOS: () => {
    return (
      /iPad|iPhone|iPod/.test(navigator.userAgent) ||
      (/Macintosh/.test(navigator.userAgent) && navigator.maxTouchPoints > 1)
    );
  },
  Opera: () => {
    return navigator.userAgent.match(/Opera Mini/i);
  },
  Windows: () => {
    return (
      navigator.userAgent.match(/IEMobile/i) ||
      navigator.userAgent.match(/WPDesktop/i)
    );
  },
  any: () => {
    return isMobile.Android() ||
      isMobile.BlackBerry() ||
      isMobile.iOS() ||
      isMobile.Opera() ||
      isMobile.Windows()
      ? true
      : false;
  },
};

export const convertBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);

    fileReader.onload = () => {
      resolve(fileReader.result)
    };

    fileReader.onerror = (error) => {
      reject(error);
    };
  })
}

export const validateDate = (dateStr) => {
  const regex = /^\d{2}\/\d{2}\/\d{4}$/;

  const listOfDays = [31,29,31,30,31,30,31,31,30,31,30,31];

  const [month, day, year] = dateStr.split('/');

  if(dateStr.match(regex) === null) {
    if(month > 12) return false;
    if(day > listOfDays[month - 1]) return false;

    return true;

  } else {
    const isoFormattedStr = `${year}-${month}-${day}`;

    const date = new Date(isoFormattedStr);
    
    const timestamp = date.getTime();
  
    if (typeof timestamp !== 'number' || Number.isNaN(timestamp)) {
      return false;
    }
  
    if(date > new Date()) {
      return false;
    }
  
    return date.toISOString().startsWith(isoFormattedStr);
  }  
}

export const onKeyPressOnlyNumber = (e) => {
  var code = (e.which) ? e.which : e.keyCode;
  if (code > 31 && (code < 48 || code > 57)) {
      e.preventDefault();
      return false;
  }
  return true;
}

export const onKeyPressAlpha = (e) => {
  var code = ('charCode' in e) ? e.charCode : e.keyCode;
  if (!(code == 32) && // space
    !(code > 64 && code < 91) && // upper alpha (A-Z)
    !(code > 96 && code < 123) &&
    !(code === 43) &&
    !(code === 45)) { // lower alpha (a-z)
    e.preventDefault();
  }
}

export const onKeyPressAlphaNumeric = (e) => {
  var code = ('charCode' in e) ? e.charCode : e.keyCode;
  if (!(code == 32) && // space
    !(code > 47 && code < 58) && // numeric (0-9)
    !(code > 64 && code < 91) && // upper alpha (A-Z)
    !(code > 96 && code < 123)) { // lower alpha (a-z)
    e.preventDefault();
  }
}

export const onKeyPressEmail = (e) => {
  var code = ('charCode' in e) ? e.charCode : e.keyCode;
  if (!(code == 32) && // space
    !(code > 47 && code < 58) && // numeric (0-9)
    !(code > 63 && code < 91) && // upper alpha (A-Z) and @
    !(code > 96 && code < 123) &&
    !(code === 45) &&
    !(code === 43) &&
    !(code === 46) &&
    !(code === 95)){ // lower alpha (a-z)
    e.preventDefault();
  }
}
export const getLoggedUserMail = (buyerName) => {
  if(!buyerName) return null;
  return buyerName.split('|')[1].split(',')[0];
}

export const animateTextBanner = () => {
  document.getElementById('text-banner').classList.toggle('animation');
  setTimeout(() => {
      document.getElementById('text-banner').classList.toggle('animation');
  }, 1000)
}

export const getFormattedPhone = (phone) => {
  return phone.replace(/[\])}[{(]/g, '').replace(/ /g, '').replace(/-/g, '').replace(/(\d{3})(\d{3})(\d{4})/, (_, a, b, c) => `(${a}) ${b}-${c}`);
}

export const getMd5Phone = (phone) => {
  return md5(phone.replace(/[()-\s]/g, ''))+"";
}

export const getSha256Phone = (phone) => {
  return sha256(phone.replace(/[()-\s]/g, ''))+"";
}

export const isValidJson = (str) => {
  try {
    JSON.parse(str);
  } catch (e) {
      return false;
  }
  return true;
}

export const handleHTTPError = (dispatch, actions, err, from?) => {
  if(!!err && !!err.status) {
    switch (err.status){
        case 401:
        case 403: dispatch(actions.setShowSessionModal(true));
            break;
        case 400: if(from === 'payment') {
          if(err.data.errors[0].errorMessage === 'A security problem has occurred. Please try another payment method or contact your financial institution.') {
            dispatch(actions.setGenericErrorModal(true, 'A security problem has occurred. Please try another payment method or contact your financial institution.'));
          } else {
            dispatch(actions.setGenericErrorModal(true, getLabelFallback('GENERIC_ERROR_MODAL_TEXT_LINE')));
          }
        }else{
          dispatch(actions.setGenericErrorModal(true, getLabelFallback('GENERIC_ERROR_MODAL_TEXT_LINE')));
        }
        break;
        default: dispatch(actions.setGenericErrorModal(true, getLabelFallback('GENERIC_ERROR_MODAL_TEXT_LINE')));
    } 
  }
}

export const mergeRefs = (...refs) => (singleRef) => {
  refs = refs.filter(a => !!a);

  refs.forEach((resolvableRef) => {
    if (typeof resolvableRef === "function") {
      resolvableRef(singleRef);
    } else {
      resolvableRef.current = singleRef;
    }
  });
};
export const isLocalhost = () => {
  return location.hostname === "localhost";
};
export const loadScript = (url, callback) => {
  let script = document.createElement("script"); // create script tag
  script.type = "text/javascript";

  // when script state is ready and loaded or complete we will call callback
  if (script.readyState) {
    script.onreadystatechange = function() {
      if (script.readyState === "loaded" || script.readyState === "complete") {
        script.onreadystatechange = null;
        callback();
      }
    };
  } else {
    script.onload = () => callback();
  }

  script.src = url; // load by url
  document.getElementsByTagName("head")[0].appendChild(script); // append to head
};

export const getInsuranceBenefits = () => {
  const ria_0_cookie = Cookies.get('ria_0');
  const ria_1_cookie = Cookies.get('ria_1');
  let ut_benefits;
  let insuranceCookie;

  try {
      insuranceCookie = ria_1_cookie !== '' ? ria_1_cookie : ria_0_cookie;
      let insuranceCookieJson;

      if (insuranceCookie !== null && insuranceCookie !== undefined && insuranceCookie !== "") {
          insuranceCookieJson = JSON.parse(insuranceCookie);
          ut_benefits = [];

          for (const key in insuranceCookieJson.data) {
              // Push only frames or lenses (that's what we offer in glasses.com)
              if(insuranceCookieJson.data.hasOwnProperty(key)) {
                  if (Array.isArray(insuranceCookieJson.data[key]) && insuranceCookieJson.data[key].length > 0 && insuranceCookieJson.data[key][0].available === true && (key === 'frames' || key === 'lenses' || key === 'exam')) {
                      ut_benefits.push(key);
                  }
              }
          }

          if (ut_benefits.length > 0) {
              ut_benefits = ut_benefits.join(",");
          } else {
              return "";
          }
      } else {
        return "";
      }

  } catch(err) {
      console.log("Can't get insurance data for tealium", err);
  }
}

export const getDiscountNames = (adj) => {
  let names = '';

  if (!adj || adj.length === 0) return names;

  const namesArray = [];

  adj.forEach(el => {
    if (el.code !== 'INSADJ') {
      if (!!el.code && el.code.length > 0) {
        namesArray.push(el.code);
      } else {
        namesArray.push(el.description);
      }
    }
  });

  names = namesArray.join(',');

  return names;

}

export const getOrderPromoCodeDiscountAmount = (data) => {
  if (!data.adjustment || !Array.isArray(data.adjustment)) {
    // Se adjustment non è presente o non è un array, restituisci 0
    return '0';
  }

  const promotionIds = data.promotionCode.flatMap(promo => promo.associatedPromotion.map(assoc => assoc.promotionId));

  const matchingAdjustment = data.adjustment.find(adj =>
    promotionIds.some(id => adj.code.includes(id))
  );

  return matchingAdjustment ? convertNumber(matchingAdjustment.amount) : '0';
}

export const getDiscoutCodes = (promotionCode) => {
  let codes = '';
  if(!promotionCode || promotionCode.length === 0) return codes;

  promotionCode.forEach(el => {
      if(el.displayLevel !== 'Order') {
        codes = codes + el.code + ','
      }
  });

  return codes.substring(0, codes.length - 1);
}

export const getInsuranceCode = () => {
  const ria_1_cookie = Cookies.get('ria_1');
  if(!ria_1_cookie || ria_1_cookie === '' || ria_1_cookie === null || ria_1_cookie === undefined) {
      return '';
  }

  const insuranceCookieJson = JSON.parse(ria_1_cookie);
  const riaInsuranceInformationJson = JSON.parse(insuranceCookieJson['riaInsuranceInformation']);
  const insuranceType = insuranceCookieJson['patientInfo'].insuranceType;
  if(!riaInsuranceInformationJson['insuranceProviderName'] || riaInsuranceInformationJson['insuranceProviderName'] === '') return '';
  if(riaInsuranceInformationJson['insuranceProviderName'] === 'FACETS'){
    if (insuranceType == 'safety') {
      return 'EyemedSafety';
    } else {
      return 'Eyemed';
    }
  }
  return riaInsuranceInformationJson['insuranceProviderName'];
}


export const roundNumber = number => {
  return (Math.round(Number(number) * 100) / 100).toFixed(1);
};

export const isThereAnAddedWarranty = (cart, oldFramerOrderItemId) => {
  return !!cart.orderItem?.find(warrantyItem => (warrantyItem.comments == "WARRANTY" && warrantyItem.xitem_field1 == oldFramerOrderItemId));
}
